'use client';

import React from 'react';
import ProductTilesCMS, {ProductTileCMSProps} from 'components/commercetools-ui/organisms/product/product-tile-cms';
import { TasticProps } from 'frontastic/tastics/types';
import InstantSearch from 'components/HOC/InstantSearch';
import LocalizedIndex from 'providers/algolia/localized-index';


const ProductTilesSliderTastic  = ({ data }: TasticProps<ProductTileCMSProps>) => {
    return (
        <InstantSearch>
        <LocalizedIndex type="products">
            <ProductTilesCMS data={data.data.dataSource} />
        </LocalizedIndex>
        </InstantSearch >
    );

};

export default ProductTilesSliderTastic;
